<template>
    <div v-if="additionals">
        <div v-if="model && additionals.salaVacinacaoLogada && !!additionals.salaVacinacaoLogada.id">
            <rkm-form ref="RkmForm">
                <rkm-area
                    title="Dados do paciente"
                    type="fieldset"
                >
                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-input
                                :value="model.cidadaoNome"
                                disabled
                                label="Nome"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :value="model.sexoDescricao"
                                disabled
                                label="Sexo"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-date-picker
                                :value="model.cidadaoDataNascimento"
                                disabled
                                label="Data de nascimento"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :value="model.cidadaoIdade"
                                disabled
                                label="Idade"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="2">
                            <rkm-form-input
                                :value="model.pacienteProntuario"
                                disabled
                                label="Prontuário"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                v-model="model.cidadaoCns"
                                label="CNS"
                                :danger="!validaCns"
                                v-mask="mask.cns"
                                :validations="pacienteValidations.cns"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-input
                                :value="model.cidadaoNomeMae"
                                disabled
                                label="Nome da mãe"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-input
                                :value="model.unidadeNomeFantasia"
                                disabled
                                label="Unidade de saúde"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="6">
                            <rkm-form-input
                                :value="model.logradouroNome"
                                disabled
                                label="Logradouro"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :value="model.enderecoNumero"
                                disabled
                                label="Número"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :value="model.enderecoComplemento"
                                disabled
                                label="Complemento"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-input
                                :value="model.enderecoReferencia"
                                disabled
                                label="Ponto de referência"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="4">
                            <rkm-form-input
                                :value="model.bairroNome"
                                disabled
                                label="Bairro"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-input
                                :value="model.municipioNome"
                                disabled
                                label="Município"
                            />
                        </rkm-col>

                        <rkm-col cols="4">
                            <rkm-form-input
                                :value="model.estadoNome"
                                disabled
                                label="Estado"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-input
                                v-model="model.cidadaoCpf"
                                label="CPF"
                                :danger="!validaCpf"
                                v-mask="mask.cpf"
                                :validations="pacienteValidations.cpf"
                            />
                        </rkm-col>

                        <rkm-col>
                            <rkm-form-input
                                v-model="model.cidadaoTelefone"
                                label="Telefone"
                                :danger="!validaTelefone"
                                v-mask="model.cidadaoTelefone && model.cidadaoTelefone.length < 15 ? mask.phone : mask.cellPhone"
                                :validations="pacienteValidations.telefone"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>

                <rkm-tabs>
                    <rkm-tab title="Aplicação / Atualização">
                        <rkm-area
                            no-margin-top
                            title="Lista de aplicação / atualização"
                        >
                            <template v-slot:trailing>
                                <rkm-button
                                    v-if="hasPermissaoAplicacao"
                                    @click="$refs.ModalAplicacao.open()"
                                    color="primary"
                                    :disabled=!!model.obito
                                    small
                                >
                                    Nova aplicação
                                </rkm-button>

                                <rkm-button
                                    @click="$refs.ModalAtualizacao.open()"
                                    color="primary"
                                    :disabled=!!model.obito
                                    small
                                >
                                    Nova atualização
                                </rkm-button>
                            </template>

                            <rkm-row>
                                <rkm-col cols="12">
                                    <rkm-table
                                        :fields="fields.registro"
                                        :items="model.registros"
                                    >
                                        <template v-slot:cell(dataRegistro)="data">
                                            {{ formatarData(data.item.dataRegistro) }}
                                        </template>

                                        <template v-slot:cell(dataCadastro)="data">
                                            {{ formatarData(data.item.dataCadastro) }}
                                        </template>

                                        <template v-slot:cell(registroTipo)="{ item }">
                                            <div class="text-nowrap">
                                                <template v-if="item.registroTipo === 'aplicacao'">Aplicação</template>
                                                <template v-else>Atualização</template>

                                                <rkm-icon
                                                    v-if="item.statusRia === 'pendente'"
                                                    icon="clock"
                                                    title="Pendente"
                                                    class="ml-1"
                                                />

                                                <rkm-icon
                                                    v-else-if="item.statusRia === 'enviado'"
                                                    icon="share"
                                                    title="Enviado"
                                                    class="ml-1"
                                                />

                                                <rkm-icon
                                                    v-else-if="item.statusRia === 'rejeitado'"
                                                    icon="ban"
                                                    title="Rejeitado"
                                                    class="ml-1"
                                                />
                                            </div>
                                        </template>

                                        <template v-slot:cell(actions)="{ index, item }">
                                            <rkm-button
                                                @click="$refs.ModalDetalhe.open(item)"
                                                color="primary"
                                                small
                                                title="Exibir detalhes"
                                            >
                                                <rkm-icon icon="bars" />
                                            </rkm-button>

                                            <template v-if="item.registroTipo === 'aplicacao'">
                                                <rkm-button
                                                    @click="$refs.ModalAplicacao.open(item, true)"
                                                    small
                                                    title="Visualizar"
                                                >
                                                    <rkm-icon icon="eye" />
                                                </rkm-button>

                                                <rkm-button
                                                    :disabled="!!item.exportado"
                                                    @click="$refs.ModalAplicacao.open(item, false, false, index)"
                                                    color="primary"
                                                    small
                                                    title="Editar"
                                                >
                                                    <rkm-icon icon="pen" />
                                                </rkm-button>

                                                <rkm-button
                                                    :disabled="!!item.exportado"
                                                    @click="destroy(item.id)"
                                                    authorize="destroy-imunizacao-registro-vacinacao"
                                                    color="danger"
                                                    small
                                                    title="Excluir"
                                                >
                                                    <rkm-icon icon="trash" />
                                                </rkm-button>
                                            </template>

                                            <template v-else>
                                                <rkm-button
                                                    @click="$refs.ModalAtualizacao.open(item, true)"
                                                    small
                                                    title="Visualizar"
                                                >
                                                    <rkm-icon icon="eye" />
                                                </rkm-button>

                                                <rkm-button
                                                    :disabled="!!item.exportado"
                                                    @click="$refs.ModalAtualizacao.open(item, false, index)"
                                                    color="primary"
                                                    small
                                                    title="Editar"
                                                >
                                                    <rkm-icon icon="pen" />
                                                </rkm-button>

                                                <rkm-button
                                                    :disabled="!!item.exportado"
                                                    @click="destroyAtualizacao(item.id)"
                                                    authorize="destroy-imunizacao-registro-vacinacao"
                                                    color="danger"
                                                    small
                                                    title="Excluir"
                                                >
                                                    <rkm-icon icon="trash" />
                                                </rkm-button>
                                            </template>
                                        </template>
                                    </rkm-table>
                                </rkm-col>
                            </rkm-row>
                        </rkm-area>
                    </rkm-tab>

                    <rkm-tab title="Aprazamento">
                        <rkm-area
                            no-margin-top
                            title="Lista de aprazamento"
                        >
                            <template v-slot:trailing>
                                <rkm-button
                                    @click="$refs.ModalAprazamento.open()"
                                    :disabled=!!model.obito
                                    color="primary"
                                    small
                                    title="Novo aprazamento"
                                >
                                    <rkm-icon icon="plus" />
                                </rkm-button>
                            </template>

                            <rkm-row>
                                <rkm-col cols="12">
                                    <rkm-table
                                        :fields="fields.aprazamento"
                                        :items="model.aprazamentos"
                                    >
                                        <template v-slot:cell(actions)="{ index, item }">
                                            <rkm-button
                                                :disabled="handleDisabledAprazamento(item)"
                                                @click="$refs.ModalAplicacao.open(item, false, true)"
                                                color="info"
                                                small
                                                title="Aplicar"
                                            >
                                                <rkm-icon icon="syringe" />
                                            </rkm-button>

                                            <rkm-button
                                                @click="$refs.ModalAprazamento.open(item, true)"
                                                small
                                                title="Visualizar"
                                            >
                                                <rkm-icon icon="eye" />
                                            </rkm-button>

                                            <rkm-button
                                                @click="$refs.ModalAprazamento.open(item, false, index)"
                                                color="primary"
                                                small
                                                title="Editar"
                                            >
                                                <rkm-icon icon="pen" />
                                            </rkm-button>

                                            <rkm-button
                                                :disabled="!!item.registroAplicacaoId"
                                                @click="destroyAprazamento(item.id)"
                                                authorize="destroy-imunizacao-registro-vacinacao"
                                                color="danger"
                                                small
                                                title="Excluir"
                                            >
                                                <rkm-icon icon="trash" />
                                            </rkm-button>
                                        </template>
                                    </rkm-table>
                                </rkm-col>
                            </rkm-row>
                        </rkm-area>
                    </rkm-tab>
                </rkm-tabs>
            </rkm-form>

            <ModalAplicacao
                :additionals="additionals"
                :form="form"
                :id="id"
                :model="model"
                ref="ModalAplicacao"
            />

            <ModalAtualizacao
                :additionals="additionals"
                :form="form"
                :id="id"
                :model="model"
                ref="ModalAtualizacao"
            />

            <ModalAprazamento
                :additionals="additionals"
                :form="form"
                :id="id"
                :model="model"
                ref="ModalAprazamento"
            />

            <ModalDetalhe
                ref="ModalDetalhe"
            />
        </div>

        <rkm-alert v-else color="warning">
            A unidade logada não é uma sala de vacinação ou está desativada, favor cadastra-la para efetuar um registro de vacinação.
        </rkm-alert>
    </div>
</template>

<script>
// Components.
import ModalAplicacao from './components/aplicacao/Modal'
import ModalAprazamento from './components/aprazamento/Modal'
import ModalAtualizacao from './components/atualizacao/Modal'
import ModalDetalhe from './components/detalhe/Modal'

// Enums.
import parametrizacaoDescricaoVacina from '@/enums/imunizacao/parametrizacaoDescricaoVacina'
import classificacao from '@/enums/cadastro/paciente/classificacao'

// Mixins.
import { error, formats, repository, stringCase, mask, unmask } from '@/mixins'

// Others.
import moment from 'moment'

// Utils.
import cns from '@/utils/validations/cns'
import cpf from '@/utils/validations/cpf'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: {
        ModalAplicacao,
        ModalAprazamento,
        ModalAtualizacao,
        ModalDetalhe
    },
    computed: {
        validaCns (){
            return this.validations.cns(this.model.cidadaoCns)
        },
        validaCpf() {
            return this.validations.cpf(this.model.cidadaoCpf)
        },
        validaTelefone() {
            return this.model.cidadaoTelefone && (this.model.cidadaoTelefone.length == 14 || this.model.cidadaoTelefone.length == 15)
        },
        fields() {
            const commonFields = []

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    commonFields.push({ key: 'vacinaAbreviacao', label: 'Abreviação da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    commonFields.push({ key: 'vacinaSigla', label: 'Sigla da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    commonFields.push({ key: 'vacinaSiglaNome', label: 'Sigla e nome da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    commonFields.push({ key: 'vacinaSiglaAbreviacao', label: 'Sigla e abreviação da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    commonFields.push({ key: 'vacinaAbreviacaoNome', label: 'Abreviação e nome da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    commonFields.push({ key: 'vacinaSiglaAbreviacaoNome', label: 'Sigla, abreviação e nome da vacina' })
                    break;

                default:
                    commonFields.push({ key: 'vacinaNome', label: 'Nome da vacina' })
                    break;
            }

            return {
                registro: [
                    { key: 'registroTipo', label: 'Tipo de registro' },
                    ...commonFields,
                    { key: 'doseNome', label: 'Dose' },
                    { key: 'dataRegistro', label: 'Data da aplicação', sortable: true },
                    { key: 'dataCadastro', label: 'Data do registro', sortable: true },
                    { key: 'unidadeNomeFantasia', label: 'Unidade' },
                    { key: 'salaVacinacaoNome', label: 'Sala de vacinação' },
                    { key: 'observacao', label: 'Observação' },
                    { class: 'col-min text-center', key: 'actions', label: 'Ações' },
                ],
                aprazamento: [
                    ...commonFields,
                    { key: 'doseNome', label: 'Dose' },
                    { key: 'dataAprazamento', label: 'Data do aprazamento' },
                    { key: 'observacao', label: 'Observação' },
                    { class: 'col-min text-center', key: 'actions', label: 'Ações' },
                ],
            }
        },
        pacienteValidations() {
            return {
                cns: {
                    required: this.additionals.parametrizacao.cnsCpfObrigatorio,
                    min_max_without_mask: 15,
                    cns: true,
                },
                cpf: {
                    required: this.additionals.parametrizacao.cnsCpfObrigatorio,
                    min_max_without_mask: 11,
                    cpf: true
                },
                telefone: {
                    min_max_without_mask: [10, 11]
                }
            }
        },
        hasPermissaoAplicacao() {
            let hasPermissao = true

            if (this.additionals && this.additionals.parametrizacao) {
                if (this.model && this.model.classificacaoId === this.enums.classificacao.OUTRO_MUNICIPIO && !this.additionals.parametrizacao.cadastroOutroMunicipio) {
                    hasPermissao = false
                }
                else if (this.model && this.model.classificacaoId === this.enums.classificacao.PROVISORIO && !this.additionals.parametrizacao.cadastroProvisorio) {
                    hasPermissao = false
                }
                else if (this.model && this.model.bloqueado && !this.additionals.parametrizacao.cadastroBloqueado) {
                    hasPermissao = false
                }
                else if (this.model && this.model.cadastroDesatualizado && !this.additionals.parametrizacao.cadastroDesatualizado) {
                    hasPermissao = false
                }
            }

            return hasPermissao
        },
    },
    created() {
        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.imunizacao'),
            registroVacinacao: this.getConectaSusRepository('imunizacao.registroVacinacao'),
        }
    },
    data: () => ({
        additionals: null,
        enums: {
            parametrizacaoDescricaoVacina,
            classificacao,
        },
        form: null,
        model: null,
        others: { moment },
        validations: { cns, cpf },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            const request = {
                pacienteId: this.id,
                filaId: this.filaId,
            }

            this.setLoading()

            this.repositories.registroVacinacao.create(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)

                    this.$emit('loaded', { additionals: this.additionals, model: this.model })

                    if (this.additionals.salaVacinacaoLogada && !!this.additionals.salaVacinacaoLogada.id) {
                        this.showMensagemAprazamento()
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        showMensagemAprazamento() {
            if (this.additionals.parametrizacao && this.additionals.parametrizacao.aprazamentoAtivo) {
                let mensagensAprazamento = []

                this.model.aprazamentos.forEach(aprazamento => {
                    const dataAtual = this.others.moment(this.additionals.dataAtual)
                    const dataAprazamento = this.others.moment(aprazamento.dataAprazamento, 'DD/MM/YYYY')
                    const diferencaDataAtualDataAprazamento = dataAtual.diff(dataAprazamento, 'days')

                    if (dataAtual > dataAprazamento) {
                        if (diferencaDataAtualDataAprazamento <= this.additionals.parametrizacao.aprazamentoDiasDepois) {
                            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                                case this.enums.parametrizacaoDescricaoVacina.ABREVIACAO:
                                    mensagensAprazamento.push(`${aprazamento.vacinaAbreviacao} - ${aprazamento.dataAprazamento}`)
                                    break;

                                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                                    mensagensAprazamento.push(`${aprazamento.vacinaSigla} - ${aprazamento.dataAprazamento}`)
                                    break;

                                default:
                                    mensagensAprazamento.push(`${aprazamento.vacinaNome} - ${aprazamento.dataAprazamento}`)
                                    break;
                            }
                        }
                    }
                    else if (dataAtual <= dataAprazamento) {
                        if ((diferencaDataAtualDataAprazamento * -1) <= this.additionals.parametrizacao.aprazamentoDiasAntes) {
                            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                                case this.enums.parametrizacaoDescricaoVacina.ABREVIACAO:
                                    mensagensAprazamento.push(`${aprazamento.vacinaAbreviacao} - ${aprazamento.dataAprazamento}`)
                                    break;

                                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                                    mensagensAprazamento.push(`${aprazamento.vacinaSigla} - ${aprazamento.dataAprazamento}`)
                                    break;

                                default:
                                    mensagensAprazamento.push(`${aprazamento.vacinaNome} - ${aprazamento.dataAprazamento}`)
                                    break;
                            }
                        }
                    }
                })

                if (mensagensAprazamento.length > 0) {
                    let mensagem = ''

                    mensagensAprazamento.forEach(mensagemAprazamento => {
                        mensagem = mensagem + `<li>${mensagemAprazamento}</li>`
                    })

                    this.showAlert(
                        `
                            O paciente possui vacinas com aprazamentos pendentes ou próximos:
                            <ul>${mensagem}</ul>
                        `,
                        'Atenção'
                    )
                }
            }
        },
        destroy(id) {
            this.showDeleteConfirmation('Deseja realmente excluir o registro?', async () => this.model.registros.splice(this.model.registros.findIndex(r => r.id == id && r.registroTipo == 'aplicacao'), 1))
        },
        destroyAtualizacao(id) {
            this.showDeleteConfirmation('Deseja realmente excluir a atualização?', async () => this.model.registros.splice(this.model.registros.findIndex(r => r.id == id && r.registroTipo == 'atualizacao'), 1))
        },
        destroyAprazamento(id) {
            this.showDeleteConfirmation('Deseja realmente excluir o aprazamento?', async () => this.model.aprazamentos.splice(this.model.aprazamentos.findIndex(a =>a.id == id), 1))
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if(valid) {
                        const request = {
                            pacienteId: this.id,
                            cidadaoCns: this.unMaskCns(this.model.cidadaoCns),
                            cidadaoCpf: this.unMaskCpf(this.model.cidadaoCpf),
                            cidadaoTelefone: this.unMaskPhone(this.model.cidadaoTelefone),
                            aplicacoes: this.model.registros.filter(registro => registro.registroTipo === 'aplicacao')
                                .map(aplicacao => {
                                    return {
                                        id: aplicacao.id,
                                        salaVacinacaoId: aplicacao.salaVacinacaoId,
                                        aplicadorId: aplicacao.aplicadorId,
                                        ocupacaoId: aplicacao.ocupacaoId,
                                        equipeId: aplicacao.equipeId,
                                        turnoId: aplicacao.turnoId,
                                        localAtendimentoId: aplicacao.localAtendimentoId,
                                        dataRegistro: aplicacao.dataRegistro,
                                        vacinaId: aplicacao.vacinaId,
                                        lote: aplicacao.lote.lote,
                                        entradaId: aplicacao.lote.id,
                                        dataValidadeLote: aplicacao.lote.dataValidadeLote,
                                        produtorId: aplicacao.produtorId,
                                        grupoAtendimentoId: aplicacao.grupoAtendimentoId,
                                        doseId: aplicacao.doseId,
                                        estrategiaId: aplicacao.estrategiaId,
                                        cidId: aplicacao.cidId,
                                        comunicanteHanseniase: aplicacao.comunicanteHanseniase,
                                        gestante: aplicacao.gestante,
                                        puerpera: aplicacao.puerpera,
                                        imunizacaoAdvertida: aplicacao.imunizacaoAdvertida,
                                        viajante: aplicacao.viajante,
                                        ultimoFrasco: aplicacao.ultimoFrasco,
                                        observacao: aplicacao.observacao,
                                        aprazamentoId: aplicacao.aprazamentoId,
                                        alterou: aplicacao.alterou ?? false,
                                    }
                                }),
                            atualizacoes: this.model.registros.filter(registro => registro.registroTipo === 'atualizacao')
                                .map(atualizacao => {
                                    return {
                                        aplicadorId: atualizacao.aplicadorId,
                                        dataRegistro: atualizacao.dataRegistro,
                                        doseId: atualizacao.doseId,
                                        estrategiaId: atualizacao.estrategiaId,
                                        entradaId: atualizacao.lote ? atualizacao.lote.id : null,
                                        equipeId: atualizacao.equipeId,
                                        grupoAtendimentoId: atualizacao.grupoAtendimentoId,
                                        id: atualizacao.id,
                                        localAtendimentoId: atualizacao.localAtendimentoId,
                                        lote: atualizacao.lote,
                                        observacao: atualizacao.observacao,
                                        ocupacaoId: atualizacao.ocupacaoId,
                                        salaVacinacaoId: atualizacao.salaVacinacaoId,
                                        turnoId: atualizacao.turnoId,
                                        vacinaId: atualizacao.vacinaId,
                                        alterou: atualizacao.alterou ?? false,
                                    }
                                }),
                            aprazamentos: this.model.aprazamentos.map(aprazamento => {
                                return {
                                    id: aprazamento.id,
                                    dataAprazamento: aprazamento.dataAprazamento,
                                    vacinaId: aprazamento.vacinaId,
                                    doseId: aprazamento.doseId,
                                    observacao: aprazamento.observacao,
                                }
                            }),
                            filaId: this.filaId,
                        }

                        this.setLoading()

                        this.repositories.registroVacinacao.store(this.camelObjectKeysToSnakeRecursive(request))
                            .then(() => {
                                this.showSaveNotification()
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
        printRegistroVacinacao() {
            this.setLoading()

            this.repositories.impressao.registroVacinacao(this.id)
                .then(response => {
                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        printCarteiraVacinacao() {
            this.setLoading()

            this.repositories.impressao.carteiraVacinacao(this.id)
                .then(response => {
                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        printCertidaoRegularidade() {
            this.setLoading()

            this.repositories.impressao.certidaoRegularidade(this.id)
                .then(response => {
                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleDisabledAprazamento(item) {

            if (this.others.moment(this.additionals.dataAtual) >= this.others.moment(item.dataAprazamento, 'DD/MM/YYYY')) {
                return false
            }

            if (this.additionals.parametrizacao && this.additionals.parametrizacao.aprazamentoAtivo) {

                const dataAtual = this.others.moment(this.additionals.dataAtual)
                const dataAprazamento = this.others.moment(item.dataAprazamento, 'DD/MM/YYYY')
                const diferencaDataAtualDataAprazamento = dataAtual.diff(dataAprazamento, 'days')

                if (dataAtual <= dataAprazamento) {
                    if ((diferencaDataAtualDataAprazamento * -1) <= this.additionals.parametrizacao.aprazamentoDiasAntes) {
                        return false
                    }
                }
            }

            return true
        },
        formatarData(data) {
            if (data instanceof Date) {
                return moment(data).format('DD/MM/YYYY');
            }
            if (typeof data === 'string') {
                const parsedDate = moment(data, ['YYYY-MM-DD', 'YYYY-MM-DDTHH:mm:ssZ','DD/MM/YYYY'], true);
                return parsedDate.isValid() ? parsedDate.format('DD/MM/YYYY') : 'Data inválida';
            }
        }
    },
    mixins: [ error, formats, repository, stringCase, mask, unmask ],
    mounted() {
        this.load()
    },
    props: {
        filaId: { type: Number, default: null },
        id: { type: Number, default: null },
    },
}
</script>